import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import ClientManagementCard from "./ClientManagementCard";
import {
  getClientManagementList,
  getClientManagementDetails,
  getClientUserDetails,
  getClientList,
} from "../Actions/ClientManagementAPI";
import { normalizeClientRecord } from "../helpers/clientManagementNormalize";
import "./UserManagementMaster.css";

const PAGE_SIZE = 15;
const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const defaultSearchData = {
  CompanyName: "",
  Mail: "",
  Phone: "",
  ClientType: "",
  PageNumber: 1,
  PageSize: PAGE_SIZE,
};

class ClientManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: { ...defaultSearchData },
      loading: false,
    };
    this.SearchClient = this.SearchClient.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onChangeClientName = this.onChangeClientName.bind(this);
    this.viewClick = this.viewClick.bind(this);
    this.editClick = this.editClick.bind(this);
    this.deleteClient = this.deleteClient.bind(this);
    this.handleAddClient = this.handleAddClient.bind(this);
  }

  componentDidMount() {
    const { dispatch, clientuserSearch, t } = this.props;
    const searchData = clientuserSearch || { ...defaultSearchData };

    this.setState({ searchData }, () => {
      dispatch(getClientManagementList(this.state.searchData));
    });

    dispatch({
      type: "SubBannerTitle",
      data: t("ClientManagementScreenContent.Title").toUpperCase(),
    });
    dispatch(getClientList());
  }

  componentDidUpdate(prevProps) {
    if (this.props.showSidePane !== prevProps.showSidePane && !this.props.showSidePane) {
      const { dispatch } = this.props;
      dispatch(getClientManagementList(this.state.searchData));
    }
  }

  onChangeClientName(event, value) {
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        CompanyName: value || "",
      },
    }));
  }

  SearchClient(pageNumber) {
    const { dispatch } = this.props;
    const searchData = {
      ...this.state.searchData,
      PageNumber: pageNumber || 1,
    };

    this.setState({ searchData, loading: true });
    dispatch({ type: "clientuserSearch", data: searchData });
    dispatch(getClientManagementList(searchData));
    this.setState({ loading: false });
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        [name]: value,
      },
    }));
  }

  ClearInput() {
    const { dispatch } = this.props;
    this.setState({ searchData: { ...defaultSearchData } });
    dispatch({ type: "clientuserSearch", data: "" });
    dispatch(getClientManagementList(defaultSearchData));
  }

  viewClick(id, item) {
    const { dispatch, history } = this.props;
    if (item) {
      dispatch({
        type: "getClientDetailsSuccess",
        data: normalizeClientRecord(item),
      });
    }
    dispatch({ type: "ShowSidePan", data: true });
    history.push(`/Home/ClientManagement/${id}`);
    dispatch(getClientManagementDetails(id));
    dispatch(getClientUserDetails(id));
    window.scrollTo(0, 0);
  }

  editClick(id) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    history.push(`/Home/ClientManagement/Edit/${id}`);
    window.scrollTo(0, 0);
  }

  deleteClient(item) {
    const { t, dispatch } = this.props;

    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const client = {
              clientId: item.clientId,
              companyName: item.companyName,
              mail: item.mail,
              address: item.address || "",
              telephone: item.telephone || "",
              clientType: item.clientType || "",
              isDeleted: true,
              modifiedBy: currentUser?.name || "",
            };

            axios
              .put(API.getClientDetails, client, {
                headers: { key: currentUser.accessToken },
              })
              .then(() => {
                dispatch(getClientList());
                dispatch(getClientManagementList(this.state.searchData));
                dispatch({ type: "ShowSidePan", data: false });
                toast.success(t("CommonText.CommonDelete"));
              })
              .catch(() => {
                toast.error(t("CommonText.500ErrorMessage"));
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
        },
      ],
    });
  }

  handleAddClient() {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "fleetManagerListSuccess", data: null });
    dispatch({ type: "techSuperintendentListSuccess", data: null });
    dispatch({ type: "techExecutiveListSuccess", data: null });
    history.push("/Home/ClientManagement/Add");
    window.scrollTo(0, 0);
  }

  renderFilterField(label, name, placeholder, iconClass, type = "text") {
    return (
      <div className="col-lg-3 col-md-6 um-filter-field">
        <label className="form-label">{label}</label>
        <div className="um-input-shell">
          <span className="um-input-icon">
            <i className={`fa ${iconClass}`} aria-hidden="true"></i>
          </span>
          <input
            className="form-control"
            type={type}
            name={name}
            placeholder={placeholder}
            value={this.state.searchData[name]}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
    );
  }

  renderCompanyNameFilter(t) {
    const { getClientLists } = this.props;

    return (
      <div className="col-lg-3 col-md-6 um-filter-field">
        <label className="form-label">{t("ShipManagementContent.CompanyName")}</label>
        <div className="um-input-shell um-autocomplete-shell">
          <span className="um-input-icon">
            <i className="fa fa-institution" aria-hidden="true"></i>
          </span>
          <div className="um-autocomplete-field-wrap">
            <Autocomplete
              value={this.state.searchData.CompanyName}
              options={getClientLists ?? []}
              getOptionLabel={(option) => option || ""}
              onChange={(event, value) => this.onChangeClientName(event, value)}
              noOptionsText={t("CommonText.NoItem")}
              freeSolo={false}
              disableClearable
              popupIcon={null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={t("ShipManagementContent.CompanyName")}
                  variant="standard"
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                  }}
                />
              )}
            />
          </div>
          <i className="fa fa-chevron-down um-field-dropdown-chevron" aria-hidden="true" />
        </div>
      </div>
    );
  }

  renderClientTypeFilter(t) {
    return (
      <div className="col-lg-3 col-md-6 um-filter-field">
        <label className="form-label">
          {t("ClientManagementScreenContent.Owner/ManagementCompany")}
        </label>
        <div className="um-input-shell">
          <span className="um-input-icon">
            <i className="fa fa-briefcase" aria-hidden="true"></i>
          </span>
          <div className="um-select-wrap">
            <select
              className="form-control um-select"
              name="ClientType"
              value={this.state.searchData.ClientType}
              onChange={this.handleInputChange}
            >
              <option value="">{t("ClientManagementScreenContent.AllTypes")}</option>
              <option value="Owner">{t("ClientManagementScreenContent.Owner")}</option>
              <option value="Management company">
                {t("ClientManagementScreenContent.ManagementCompany")}
              </option>
            </select>
            <i className="fa fa-chevron-down um-field-dropdown-chevron" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { ClientList, showSidePane, t } = this.props;
    const { loading } = this.state;
    const clients = (ClientList?.data || []).map(normalizeClientRecord);
    const pagination = ClientList?.pagination || {
      totalcount: 0,
      pageSize: PAGE_SIZE,
      currentPage: 1,
    };

    return (
      <div className="full-height user-module-master">
        <div className="pt-3">
          <div className="row">
            <div className="col-12">
              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    <i className="fa fa-filter um-section-title-icon" aria-hidden="true"></i>
                    {t("ClientContactUserManagementContent.SearchFilters")}
                  </h5>
                </div>
                <div className="um-section-body">
                  <div className="row um-filter-grid">
                    {this.renderCompanyNameFilter(t)}
                    {this.renderFilterField(
                      t("ServicedByScreenContent.Email"),
                      "Mail",
                      t("ServicedByScreenContent.Email"),
                      "fa-envelope-o",
                      "email"
                    )}
                    {this.renderFilterField(
                      t("ClientManagementScreenContent.Phone"),
                      "Phone",
                      t("ClientManagementScreenContent.Phone"),
                      "fa-phone"
                    )}
                    {this.renderClientTypeFilter(t)}
                  </div>
                  <div className="um-actions">
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-btn um-btn-primary"
                      type="button"
                      onClick={() => this.SearchClient(1)}
                      disabled={loading}
                    >
                      {t("content.Search")}
                    </button>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn um-btn um-btn-secondary"
                      type="button"
                      onClick={this.ClearInput}
                      disabled={loading}
                    >
                      {t("content.Clear")}
                    </button>
                  </div>
                </div>
              </div>

              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    <i className="fa fa-institution um-section-title-icon" aria-hidden="true"></i>
                    {t("ClientManagementScreenContent.Title")}
                  </h5>
                  <button
                    type="button"
                    className="um-header-add-btn"
                    onClick={this.handleAddClient}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>
                    <span>{t("ShipManagementContent.Add")}</span>
                  </button>
                </div>
                <div className="um-list-body">
                  <ClientManagementCard
                    currentPage={pagination.currentPage || 1}
                    arraylist={clients}
                    pageSize={pagination.pageSize || PAGE_SIZE}
                    totalRecords={pagination.totalcount || 0}
                    setUpdatedState={(value) => this.SearchClient(value)}
                    viewClick={(id, item) => this.viewClick(id, item)}
                    editClick={(id) => this.editClick(id)}
                    deleteClient={(item) => this.deleteClient(item)}
                    showSidePane={showSidePane}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ClientList: state.MasterScreenReducer.ClientList,
    getClientLists: state.MasterScreenReducer.getClientLists,
    clientuserSearch: state.MasterScreenReducer.clientuserSearch,
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientManagement))
);
